import { connect } from 'react-redux';
import { toggleSubmitMenu } from '../../redux/actions';
import { showSubmitModal } from '../../../Modals/redux/actionCreators';
import { flagEnabled } from '../../../redux/flags';
import { restrictLoggedOut } from '../../../redux/loggedout/actionCreators';
import { getIsLoggedIn } from '../../../publicSession';
var mapStateToProps = function (state) { return ({
    isAllowingCommissionSubmission: flagEnabled(state, 'submit_commission'),
    isLoggedIn: getIsLoggedIn(state),
}); };
var mapDispatchToProps = {
    showSubmitModal: showSubmitModal,
    restrictLoggedOut: restrictLoggedOut,
    toggleSubmitMenu: toggleSubmitMenu,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SubmitMenu.container.js.map